<template>
  <LayoutPage class="news-page vidburdir-page">
    <PostsFilter
      v-if="!!posts"
      :posts="posts"
      @getLimitPosts="init()"
    />
  </LayoutPage>
</template>

<script>
import { categories } from '@/staticData/blog'
import LayoutPage from '@/layout/blog'
import PostsFilter from '@/components/Blog/AllPosts/PostsFilter/_index'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  components: {
    LayoutPage,
    PostsFilter
  },
  methods: {
    ...mapActions('blog',{
      // setDataPage: 'SET_DATA_BLOG_PAGE',
      getDataPage: 'GET_DATA_BLOG_PAGE',
    }),
    ...mapMutations({
      setData: 'SET_DATA'
    }),
    init() {
      if (this.loading) return
      const hasPosts = !!this.dataPage.posts.length
      this.getDataPage({
        categoryId: categories[1].id, 
        limit: hasPosts ? this.dataPage.posts.length + this.limit : this.limit
      })
    }
  },
  computed: {
    ...mapState('blog', {
      limit: state => state.limit,
      loading: state => state.loading
    }),
    ...mapGetters('blog',{
      dataPage: 'GET_DATA_BLOG_PAGE'
    }),
    posts() {
      return this.dataPage && this.dataPage.posts
        ? this.dataPage.posts.filter((post) => post.category_id === 2)
        : null 
    }
  },
  created () {
    this.init()
  },
  beforeDestroy() {
    this.setData({
      field: 'blog.blogPage.posts',
      data: []
    })
  }
}
</script>
